
<div class="flex justify-center items-start min-h-screen bg-gray-50 p-2 sm:p-4">
  
  <div class="w-full max-w-4xl bg-white rounded-lg sm:rounded-xl shadow-md overflow-hidden mx-auto">
    
     <div class="flex justify-center bg-orange-50 p-4 border-b border-orange-100">
      <img src="/assets/images/logo/oneci_logo.svg" alt="ONECI Logo" class="h-16">
    </div>
    
    <div class="px-3 sm:px-5 py-4 sm:py-5">
      <!-- Barre de progression (Stepper) responsive -->
      <div class="flex justify-between items-center mb-4 sm:mb-6">
        <!-- Étape 1 -->
        <div class="flex flex-col items-center" (click)="goToStep(1)" style="cursor: pointer;">
          <div [ngClass]="{'bg-orange-600': currentStep >= 1, 'bg-gray-300': currentStep < 1}" 
               class="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
            1
          </div>
          <span class="text-xs sm:text-sm mt-1 text-center" [ngClass]="{'text-orange-600 font-medium': currentStep >= 1}">
            Informations<br class="block">Générales
          </span>
        </div>
        
        <div class="h-1 sm:h-2 flex-1 mx-1" [ngClass]="{'bg-orange-600': currentStep >= 2, 'bg-gray-300': currentStep < 2}"></div>
        
        <!-- Étape 2 -->
        <div class="flex flex-col items-center" (click)="goToStep(2)" style="cursor: pointer;">
          <div [ngClass]="{'bg-orange-600': currentStep >= 2, 'bg-gray-300': currentStep < 2}" 
               class="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
            2
          </div>
          <span class="text-xs sm:text-sm mt-1 text-center" [ngClass]="{'text-orange-600 font-medium': currentStep >= 2}">
            Email
          </span>
        </div>
        
        <div class="h-1 sm:h-2 flex-1 mx-1" [ngClass]="{'bg-orange-600': currentStep >= 3, 'bg-gray-300': currentStep < 3}"></div>
        
        <!-- Étape 3 -->
        <div class="flex flex-col items-center" (click)="goToStep(3)" style="cursor: pointer;">
          <div [ngClass]="{'bg-orange-600': currentStep >= 3, 'bg-gray-300': currentStep < 3}" 
               class="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
            3
          </div>
          <span class="text-xs sm:text-sm mt-1 text-center" [ngClass]="{'text-orange-600 font-medium': currentStep >= 3}">
            Informations<br class="block">personnelles
          </span>
        </div>
        
        <!-- Ligne entre 3 et 4 -->
        <div class="h-1 sm:h-2 flex-1 mx-1" [ngClass]="{'bg-orange-600': currentStep >= 4, 'bg-gray-300': currentStep < 4}"></div>
        
        <!-- Étape 4 -->
        <div class="flex flex-col items-center" (click)="goToStep(4)" style="cursor: pointer;">
          <div [ngClass]="{'bg-orange-600': currentStep >= 4, 'bg-gray-300': currentStep < 4}" 
               class="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
            4
          </div>
          <span class="text-xs sm:text-sm mt-1 text-center" [ngClass]="{'text-orange-600 font-medium': currentStep >= 4}">
            Signature
          </span>
        </div>
        
        <!-- Ligne entre 4 et 5 -->
        <div class="h-1 sm:h-2 flex-1 mx-1" [ngClass]="{'bg-orange-600': currentStep >= 5, 'bg-gray-300': currentStep < 5}"></div>
        
        <!-- Étape 5 -->
        <div class="flex flex-col items-center" (click)="goToStep(5)" style="cursor: pointer;">
          <div [ngClass]="{'bg-orange-600': currentStep >= 5, 'bg-gray-300': currentStep < 5}" 
               class="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg">
            5
          </div>
          <span class="text-xs sm:text-sm mt-1 text-center" [ngClass]="{'text-orange-600 font-medium': currentStep >= 5}">
            Récapitulatif
          </span>
        </div>
      </div>

      
      
      <form [formGroup]="inscriptionForm" (ngSubmit)="confirmSave()">
        <!-- Step 1: Informations de la réunion -->
        @if (currentStep === 1) {
          <div class="p-4 sm:p-5">
            <h2 class="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-5">Informations de la réunion</h2>
            
            <div class="bg-gray-50 p-4 sm:p-5 rounded-lg border border-gray-200">
              <div class="space-y-3 sm:space-y-4 text-base sm:text-lg text-gray-700">
                <div>
                  <h3 class="font-medium text-orange-600">Titre</h3>
                  <p>{{ reunionInfo.titre || "-" }}</p>
                </div>
                
                <div>
                  <h3 class="font-medium text-orange-600">Date</h3>
                  <p>{{ reunionInfo.date || "-"}} </p>
                </div>
                <div>
                  <h3 class="font-medium text-orange-600">Date & Heure</h3>
                  <p> {{ reunionInfo.heureDebut || "-"}} - {{ reunionInfo.heureFin || "-"}}</p>
                </div>
                
                <div>
                  <h3 class="font-medium text-orange-600">Lieu</h3>
                  <p>{{ reunionInfo.lieu || "-"}}</p>
                </div>
                
                <div>
                  <h3 class="font-medium text-orange-600">Description</h3>
                  <p>{{ reunionInfo.description || "-"}}</p>
                </div>
               
                <!-- Affichage de l'ordre du jour standard -->
                @if (!isSeanceMultiple) {
                  <div>
                    <h3 class="font-medium text-orange-600">Ordre du Jour</h3>
                    <p>{{ reunionInfo.ordreDuJour || "-"}}</p>
                  </div>
                }
                
                <!-- Tableau des séances - Responsive -->
                @if (isSeanceMultiple && seances.length > 0) {
                  <div>
                    <h3 class="font-medium text-orange-600">Ordre du jour détaillé</h3>
                    <div class="mt-3 overflow-x-auto">
                      <table class="min-w-full bg-white border border-gray-200 rounded-md">
                        <thead>
                          <tr class="bg-gray-100">
                            <th class="px-3 py-2 sm:px-4 sm:py-3 text-left text-sm sm:text-base font-semibold text-gray-700">Date</th>
                            <th class="px-3 py-2 sm:px-4 sm:py-3 text-left text-sm sm:text-base font-semibold text-gray-700">Horaire</th>
                            <th class="px-3 py-2 sm:px-4 sm:py-3 text-left text-sm sm:text-base font-semibold text-gray-700">Libellé</th>
                            <th class="px-3 py-2 sm:px-4 sm:py-3 text-left text-sm sm:text-base font-semibold text-gray-700">Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (seance of seances; track seance.id) {
                            <tr class="border-t border-gray-200 hover:bg-gray-50">
                              <td class="px-3 py-2 sm:px-4 sm:py-3 text-sm sm:text-base text-gray-700">{{ seance.dateJour || '-' }}</td>
                              <td class="px-3 py-2 sm:px-4 sm:py-3 text-sm sm:text-base text-gray-700">{{ seance.heureDebut || '-' }} - {{ seance.heureFin || '-' }}</td>
                              <td class="px-3 py-2 sm:px-4 sm:py-3 text-sm sm:text-base text-gray-700">{{ seance.libelleSeance || '-' }}</td>
                              <td class="px-3 py-2 sm:px-4 sm:py-3 text-sm sm:text-base text-gray-700">
                                <div [innerHTML]="formatDescription(seance.description)"></div>
                              </td>
                            </tr>
                          } @empty {
                            <tr>
                              <td colspan="4" class="px-4 py-3 text-center text-base text-gray-500">Aucun élément trouvé</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              </div>
            </div>
            
            <div class="mt-5 sm:mt-6 flex justify-end">
              <button 
                type="button" 
                (click)="goToStep(2)" 
                class="px-4 py-2 sm:px-6 sm:py-3 bg-orange-600 text-white font-medium rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition text-base sm:text-lg"
              >
                Suivant
              </button>
            </div>
          </div>
        }
        
        <!-- Step 2: Email -->
        <div *ngIf="currentStep === 2" class="p-4 sm:p-5">
          <h2 class="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-5">Votre email</h2>
          
          <div class="bg-white p-4 sm:p-5 rounded-lg border border-gray-200">
            <div class="mb-4 sm:mb-5">
              <label for="email" class="block text-base sm:text-lg font-medium text-gray-700 mb-1 sm:mb-2">Email<span class="text-red-500">*</span></label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="w-full px-3 py-2 sm:px-4 sm:py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-base sm:text-lg"
                placeholder="exemple@email.com"
                [disabled]="loading"
              >
              <div *ngIf="formControls['email'].invalid && (formControls['email'].dirty || formControls['email'].touched)" class="text-red-500 text-sm sm:text-base mt-1 sm:mt-2">
                Veuillez entrer une adresse email valide
              </div>
            </div>
            
            <!-- Case de confidentialité -->
            <div class="mt-4 sm:mt-5 flex items-start">
              <div class="flex items-center h-5 sm:h-6">
                <input 
                  id="confidentialite" 
                  type="checkbox" 
                  [(ngModel)]="confidentialiteAcceptee" 
                  [ngModelOptions]="{standalone: true}"
                  class="w-5 h-5 sm:w-6 sm:h-6 border border-gray-300 rounded focus:ring-orange-500 text-orange-600"
                  [disabled]="loading"
                >
              </div>
              <div class="ml-3 text-sm sm:text-base">
                <label for="confidentialite" class="font-medium text-gray-700">
                  J'accepte les <a href="javascript:void(0)" (click)="openConfidentialitePopup()" class="text-orange-600 hover:text-orange-800">paramètres de confidentialité</a>
                </label>
              </div>
            </div>
          </div>
          
          <div class="mt-5 sm:mt-6 flex justify-between">
            <button 
              type="button" 
              (click)="goToStep(1)" 
              class="px-4 py-2 sm:px-6 sm:py-3 bg-gray-200 text-gray-700 font-medium rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 transition text-base sm:text-lg"
              [disabled]="loading"
            >
              Précédent
            </button>
            
            <button 
              type="button" 
              [disabled]="formControls['email'].invalid || !confidentialiteAcceptee || loading"
              (click)="goToStep(3)" 
              class="px-4 py-2 sm:px-6 sm:py-3 bg-orange-600 text-white font-medium rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition text-base sm:text-lg flex items-center"
              [ngClass]="{'opacity-50 cursor-not-allowed': formControls['email'].invalid || !confidentialiteAcceptee || loading}"
            >
              <!-- Indicateur de chargement -->
              <svg *ngIf="loading" class="animate-spin -ml-1 mr-2 h-4 w-4 sm:h-5 sm:w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              
              {{ loading ? 'Vérification...' : 'Suivant' }}
            </button>
          </div>
        </div>
        
        <!-- Step 3: Informations personnelles -->
        <div *ngIf="currentStep === 3" class="p-4 sm:p-5">
          <h2 class="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-5">Vos coordonnées</h2>
          
          <div class="bg-white p-4 sm:p-5 rounded-lg border border-gray-200 space-y-3 sm:space-y-4">
            <div class="grid grid-cols-1 gap-4 sm:gap-5">
              <div>
                <label for="nom" class="block text-base sm:text-lg font-medium text-gray-700 mb-1 sm:mb-2">Nom <span class="text-red-500">*</span></label>
                <input 
                  type="text" 
                  id="nom" 
                  formControlName="nom" 
                  class="w-full px-3 py-2 sm:px-4 sm:py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-base sm:text-lg"
                  placeholder="Entrez votre nom"
                >
                <div *ngIf="formControls['nom'].invalid && (formControls['nom'].dirty || formControls['nom'].touched)" class="text-red-500 text-sm sm:text-base mt-1 sm:mt-2">
                  Ce champ est requis
                </div>
              </div>
              <div>
                <label for="prenoms" class="block text-base sm:text-lg font-medium text-gray-700 mb-1 sm:mb-2">Prénoms <span class="text-red-500">*</span></label>
                <input 
                  type="text" 
                  id="prenoms" 
                  formControlName="prenoms" 
                  class="w-full px-3 py-2 sm:px-4 sm:py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-base sm:text-lg"
                  placeholder="Entrez votre prénom"
                >
                <div *ngIf="formControls['prenoms'].invalid && (formControls['prenoms'].dirty || formControls['prenoms'].touched)" class="text-red-500 text-sm sm:text-base mt-1 sm:mt-2">
                  Ce champ est requis
                </div>
              </div>
              <div>
                <label for="telephone" class="block text-base sm:text-lg font-medium text-gray-700 mb-1 sm:mb-2">Contact <span class="text-red-500">*</span></label>
                <input 
                  type="tel" 
                  id="telephone" 
                  formControlName="telephone" 
                  class="w-full px-3 py-2 sm:px-4 sm:py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-base sm:text-lg"
                  placeholder="Entrez votre contact"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  (keypress)="onlyNumberKey($event)"
                >
                <div *ngIf="formControls['telephone'].invalid && (formControls['telephone'].dirty || formControls['telephone'].touched)" class="text-red-500 text-sm sm:text-base mt-1 sm:mt-2">
                  Veuillez entrer un numéro valide (chiffres seulement)
                </div>
              </div>
              
              <div>
                <label for="fonction" class="block text-base sm:text-lg font-medium text-gray-700 mb-1 sm:mb-2">Fonction <span class="text-red-500">*</span></label>
                <input 
                  type="text" 
                  id="fonction" 
                  formControlName="fonction" 
                  class="w-full px-3 py-2 sm:px-4 sm:py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-base sm:text-lg"
                  placeholder="Entrez votre fonction"
                >
              </div>
              
              <div>
                <label for="societe" class="block text-base sm:text-lg font-medium text-gray-700 mb-1 sm:mb-2">Société <span class="text-red-500">*</span></label>
                <input 
                  type="text" 
                  id="societe" 
                  formControlName="societe" 
                  class="w-full px-3 py-2 sm:px-4 sm:py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-base sm:text-lg"
                  placeholder="Nom de votre société"
                >
              </div>
            </div>
            
            <input type="hidden" formControlName="longitudePresence">
            <input type="hidden" formControlName="latitudePresence">
          </div>
          
          <div class="mt-5 sm:mt-6 flex justify-between">
            <button 
              type="button" 
              (click)="goToStep(2)" 
              class="px-4 py-2 sm:px-6 sm:py-3 bg-gray-200 text-gray-700 font-medium rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 transition text-base sm:text-lg"
            >
              Précédent
            </button>
            <button 
              type="button" 
             [disabled]="formControls['prenoms'].invalid || formControls['nom'].invalid || 
            formControls['telephone'].invalid || formControls['societe'].invalid || 
            formControls['fonction'].invalid"
              (click)="goToStep(4)" 
              class="px-4 py-2 sm:px-6 sm:py-3 bg-orange-600 text-white font-medium rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition text-base sm:text-lg"
              [ngClass]="{'opacity-50 cursor-not-allowed': formControls['prenoms'].invalid || formControls['nom'].invalid}"
            >
              Suivant
            </button>
          </div>
        </div>
        
        <!-- Step 4: Signature -->
        <div *ngIf="currentStep === 4" class="p-4 sm:p-5">
          <h2 class="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-5">Signature</h2>
          
          <div class="bg-white p-4 sm:p-5 rounded-lg border border-gray-200">
            <!-- Signature -->
            <div class="mt-3 sm:mt-4">
              <label class="block text-base sm:text-lg font-medium text-gray-700 mb-2 sm:mb-3">Signature</label>
              <div class="relative">
                <canvas 
                  #canvas 
                  class="w-full h-32 sm:h-48 border border-gray-300 rounded-md bg-gray-50"
                ></canvas>
                
                <div *ngIf="!hasSignature" class="absolute inset-0 flex items-center justify-center text-gray-400 pointer-events-none text-base sm:text-lg">
                  <span>Signez ici</span>
                </div>
              </div>
              
              <div class="flex space-x-2 sm:space-x-3 mt-2 sm:mt-3">
                <button 
                  type="button" 
                  (click)="clear()" 
                  class="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-500 transition text-sm sm:text-base"
                >
                  Effacer
                </button>
              </div>
            </div>
          </div>
          
          <div class="mt-5 sm:mt-6 flex justify-between">
            <button 
              type="button" 
              (click)="goToStep(3)" 
              class="px-4 py-2 sm:px-6 sm:py-3 bg-gray-200 text-gray-700 font-medium rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 transition text-base sm:text-lg"
            >
              Précédent
            </button>
            <button 
              type="button" 
              [disabled]="!hasSignature"
              (click)="goToStep(5)" 
              class="px-4 py-2 sm:px-6 sm:py-3 bg-orange-600 text-white font-medium rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition text-base sm:text-lg"
              [ngClass]="{'opacity-50 cursor-not-allowed': !hasSignature}"
            >
              Suivant
            </button>
          </div>
        </div>

        <div *ngIf="currentStep === 5" class="p-4 sm:p-5">
  <h2 class="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-5">Récapitulatif</h2>
  
  <div class="bg-white p-4 sm:p-5 rounded-lg border border-gray-200 space-y-4">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <h3 class="font-medium text-orange-600 mb-2">Informations personnelles</h3>
        <div class="space-y-1 text-sm">
          <p><strong>Email:</strong> {{ inscriptionForm.get('email')?.value }}</p>
          <p><strong>Nom:</strong> {{ inscriptionForm.get('nom')?.value }}</p>
          <p><strong>Prénoms:</strong> {{ inscriptionForm.get('prenoms')?.value }}</p>
          <p><strong>Téléphone:</strong> {{ inscriptionForm.get('telephone')?.value }}</p>
          <p><strong>Fonction:</strong> {{ inscriptionForm.get('fonction')?.value }}</p>
          <p><strong>Société:</strong> {{ inscriptionForm.get('societe')?.value }}</p>
        </div>
      </div>
      
      <div>
        <h3 class="font-medium text-orange-600 mb-2">Réunion</h3>
        <div class="space-y-1 text-sm">
          <p><strong>Titre:</strong> {{ reunionInfo.titre }}</p>
          <p><strong>Date:</strong> {{ reunionInfo.date }}</p>
          <p><strong>Horaire:</strong> {{ reunionInfo.heureDebut }} - {{ reunionInfo.heureFin }}</p>
          <p><strong>Lieu:</strong> {{ reunionInfo.lieu }}</p>
        </div>
      </div>
    </div>
    
    <div *ngIf="hasSignature" class="mt-4">
      <h3 class="font-medium text-orange-600 mb-2">Signature</h3>
      <div class="border border-gray-300 rounded p-2 bg-gray-50">
        <img [src]="signatureDataURL" alt="Signature" class="max-h-20">
      </div>
    </div>
  </div>
  
  <div class="mt-5 sm:mt-6 flex justify-between">
    <button 
      type="button" 
      (click)="goToStep(4)" 
      class="px-4 py-2 sm:px-6 sm:py-3 bg-gray-200 text-gray-700 font-medium rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 transition text-base sm:text-lg"
    >
      Précédent
    </button>
    <button 
      type="submit" 
      [disabled]="inscriptionForm.invalid && !hasSignature || loading"
      class="px-4 py-2 sm:px-6 sm:py-3 bg-orange-600 text-white font-medium rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition text-base sm:text-lg flex items-center"
      [ngClass]="{'opacity-50 cursor-not-allowed': inscriptionForm.invalid || !hasSignature || loading}"
    >
      <!-- Indicateur de chargement -->
      <svg *ngIf="loading" class="animate-spin -ml-1 mr-2 h-4 w-4 sm:h-5 sm:w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      {{ loading  ? 'Enregistrement...' : 'Enregistrer' }}
    </button>
  </div>
</div>

<!-- Step 6: Confirmation -->
<div *ngIf="currentStep === 6" class="p-4 sm:p-5">
  <div class="text-center">
    <!-- Icône de succès -->
    <div class="mx-auto flex items-center justify-center h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-green-100 mb-4 sm:mb-6">
      <svg class="h-10 w-10 sm:h-12 sm:w-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
    </div>
    
    <!-- Message de confirmation -->
    <h2 class="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-3 sm:mb-4">Enregistrement confirmé !</h2>
    
    <div class="bg-green-50 border border-green-200 rounded-lg p-4 sm:p-6 mb-4 sm:mb-6">
      <p class="text-base sm:text-lg text-green-800 mb-2 sm:mb-3">
        <strong>Félicitations {{ inscriptionForm.get('prenoms')?.value }} {{ inscriptionForm.get('nom')?.value }} !</strong>
      </p>
      <p class="text-sm sm:text-base text-green-700">
        Votre présence à la réunion <strong>"{{ reunionInfo.titre }}"</strong> a été enregistrée avec succès.
      </p>
    </div>
  
    <!-- <button 
      type="button" 
      (click)="closeRegistration()" 
      class="px-6 py-2 sm:px-8 sm:py-3 bg-gray-600 text-white font-medium rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition text-base sm:text-lg"
    >
      Fermer
    </button> -->
  </div>
</div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="showConfidentialitePopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3 sm:p-4">
  <div class="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
    <div class="p-4 sm:p-6">
      <div class="flex justify-between items-center mb-4 sm:mb-5">
        <h3 class="text-lg sm:text-xl font-bold text-gray-800">Politique de confidentialité - Gestion de présence</h3>
        <button (click)="closeConfidentialitePopup()" class="text-gray-500 hover:text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 sm:h-7 sm:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="prose prose-sm sm:prose">
        <p class="font-semibold text-base sm:text-lg mb-3 sm:mb-4">Mention de Confidentialité et de Consentement</p>
        
        <h4 class="font-medium text-gray-800 mb-2 sm:mb-3"> En apposant ma signature ci-dessous, je reconnais et accepte ce qui suit :</h4>
        <ol class="list-decimal pl-4 sm:pl-5 space-y-2 sm:space-y-3">
          <li class="text-gray-700 text-sm sm:text-base">
            <span class="font-bold">Collecte des Données :</span><br>
            Je comprends que mes informations personnelles, notamment mon nom, ma date de présence et l'heure d'arrivée et de départ, seront collectées et enregistrées électroniquement.
          </li>
          <li class="text-gray-700 text-sm sm:text-base">
            <span class="font-bold">Utilisation des Données :</span><br>
            Je suis informé(e) que ces données seront utilisées uniquement à des fins de gestion de présence et de sécurité au sein de l'ONECI.
          </li>
          <li class="text-gray-700 text-sm sm:text-base">
            <span class="font-bold">Conservation et Sécurité :</span><br>
            Je suis conscient(e) que mes données seront conservées de manière sécurisée et confidentielle, conformément à la politique de conservation des données de l'ONECI, et ne seront accessibles qu'aux personnes autorisées.
          </li>
          <li class="text-gray-700 text-sm sm:text-base">
            <span class="font-bold">Droits :</span><br>
            Je reconnais avoir le droit d'accéder à mes données personnelles, de demander leur rectification ou suppression, conformément à la législation en vigueur sur la protection des données personnelles.
          </li>
          <li class="text-gray-700 text-sm sm:text-base">
            <span class="font-bold">Consentement :</span><br>
            Par ma signature, je donne mon consentement éclairé à la collecte et au traitement de mes données personnelles.
          </li>
        </ol>
      </div>
      <div class="mt-5 sm:mt-6 flex justify-end">
        <button 
          (click)="closeConfidentialitePopup()" 
          class="px-4 py-2 sm:px-6 sm:py-3 bg-orange-600 text-white rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm sm:text-base font-medium"
        >
          Fermer
        </button>
      </div>
    </div>
  </div>
</div>